import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getCashFlow(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createCashFlow(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/cash-flow" + pathname, body);
}

export async function updateCashFlow(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/cash-flow" + pathname + queryParams, body);
}

export async function deleteCashFlow(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/cash-flow" + pathname + queryParams);
}

export async function verifyCashFlow(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/cash-flow" + pathname, body);
}
